import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/clubs/$slug/admin/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/clubs/$slug/admin/disputes",
      params: { slug: params.slug },
      search: {
        status: "all_unresolved",
        sort: "oldest",
        claim: "all",
        claimer: "all",
        dispute: undefined,
      },
    });
  },
});
